import { render, staticRenderFns } from "./AccountLinkFragment.vue?vue&type=template&id=a1de7cca&"
import script from "./AccountLinkFragment.vue?vue&type=script&lang=js&"
export * from "./AccountLinkFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/workspace/npm-packages/global-vue-components-commit/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1de7cca')) {
      api.createRecord('a1de7cca', component.options)
    } else {
      api.reload('a1de7cca', component.options)
    }
    module.hot.accept("./AccountLinkFragment.vue?vue&type=template&id=a1de7cca&", function () {
      api.rerender('a1de7cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/AccountLinkFragment.vue"
export default component.exports